import aTokensGoerli from '../../tokens/aTokensGoerli.json';
import aTokensMainnet from '../../tokens/aTokensMainnet.json';
export var LENDING_POOL_ADDRESSES = [{ address: '0x7d2768dE32b0b80b7a3454c06BdAc94A69DDc7A9', chainId: 1 }];
export var PROTOCOL_DATA_PROVIDER_ADDRESSES = [{ address: '0x057835Ad21a177dbdd3090bB1CAE03EaCF78Fc6d', chainId: 1 }];
export var PRICE_ORACLE_ADDRESSES = [{ address: '0xa50ba011c48153de246e5192c8f9258a2ba79ca9', chainId: 1 }];
export var ASSET_APY_TYPES = [
    { key: 'supplyAPY', value: 'supplyAPY' },
    { key: 'stableBorrowAPY', value: 'stableBorrowAPY' },
    { key: 'variableBorrowAPY', value: 'variableBorrowAPY' },
];
export var A_TOKENS = {
    1: aTokensMainnet,
    5: aTokensGoerli,
    10: [],
    42161: [],
    8453: [],
    421613: [],
    11155111: [],
};
